import * as React from 'react'
import { ReactElement } from 'react'
import useEntity from '../../hooks/useEntity'
import Loading from '../../components/Loading'
import LegalPersonForm, { LegalPersonMutationDto } from '../../components/Form/Party/LegalPersonForm'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { CreateDto } from '../../config/filePartyConfig'
import { AddPartyProps, PartyStatus } from '../../components/Form/Party/PartyForm'
import useAxios from '../../hooks/useAxios'
import useAttributes, { AttributeContextType, AttributeViewType, EntityAttributeType } from '../../hooks/useAttributes'

export default function AddLegalPerson(): ReactElement {
    const axios = useAxios()
    const history = useHistory<{ reload: boolean }>()
    const location = useLocation()

    const attributes = useAttributes(AttributeViewType.Input, [AttributeContextType.LegalPerson], undefined, EntityAttributeType.Party)
    const { fileId } = useParams<{ fileId?: string }>()
    // Populate the payment term fields.
    const [scaffold] = useEntity<LegalPersonMutationDto>(() => ({ url: '/party/legal/scaffold', method: 'POST' }), false)

    const initialValues = {
        ...scaffold.data,
        status: PartyStatus.Active,
    } as LegalPersonMutationDto

    attributes.applyDefaultValues(initialValues)

    if (!scaffold.loaded) {
        return <Loading />
    }

    return (
        <LegalPersonForm
            formikProps={{
                initialValues,
            }}
            onSubmit={(party: LegalPersonMutationDto) =>
                axios.post<string>('/party/legal', {
                    ...party,
                    pivot: fileId ? ({ fileId, ...((location.state as AddPartyProps) || {}) } as CreateDto) : undefined,
                })
            }
            goBack={() => history.goBack()}
            attributes={attributes}
        />
    )
}
